<template>
  <div class="">
    <div>
      <b-overlay
        :show="this.showOverlay"
        no-wrap
        variant="info"
        :opacity="0.5"
        rounded="sm"
        ><template #overlay>
          <b-spinner
            style="width: 3rem; height: 3rem;"
            type="grow"
            label="Uploading..."
            variant="light"
          ></b-spinner>
          <div class="text-center">
            <p id="cancel-label">File is Uploading...</p>
          </div>
        </template>
      </b-overlay>
      <b-card
        border-variant="secondary"
        align="center"
        header-bg-variant="light"
        footer-tag="footer"
      >
        <h4 class="">File Management</h4>
        <h4 class="">Manage Files for Device: {{ HumanName }}</h4>
      </b-card>
      <!-- <b-row
        ><b-col>
          <h2>File Management</h2>
          <h2>Manage files for Device: {{ DeviceID }}</h2>
        </b-col></b-row
      > -->
      <br />
      <b-card
        border-variant="secondary"
        align="center"
        header-bg-variant="light"
        footer-tag="footer"
      >
        <div class="Upload">
          <label>Choose File to upload:</label>
          <br />
          <label for="file-upload" class="custom-file-upload">
            <b-icon-file-plus-fill></b-icon-file-plus-fill>

            Select File
          </label>
          <input
            id="file-upload"
            type="file"
            @change="handleFileUpload($event)"
            @click="resetValue()"
          />
        </div>
        <br />
        <h5 v-if="this.file.name">File Name: {{ this.file.name }}</h5>
        <p v-if="this.file.type">File Type: {{ this.file.type }}</p>
        <b-button
          variant="outline-info"
          v-on:click="submitFile()"
          class="mr-1"
          v-if="this.file.name"
          >Upload<b-icon-cloud-arrow-up-fill></b-icon-cloud-arrow-up-fill
        ></b-button>
        <b-button
          variant="outline-danger"
          v-on:click="cancelChooseFile()"
          class="mr-1"
          v-if="this.file.name"
          >Cancel</b-button
        >
      </b-card>
      <b-row>
        <b-col>
          <p>.</p>
        </b-col>
      </b-row>
    </div>
    <b-card
      border-variant="secondary"
      align="center"
      header-bg-variant="light"
      footer-tag="footer"
    >
      <div id="Table">
        <h4>Current Stored Files</h4>
        <b-table
          stacked="sm"
          id="AttachmentsTable"
          hover
          sticky-header
          no-border-collapse
          responsive
          small
          :items="this.items"
          :fields="this.NewHeaders"
          show-empty
          empty-text="There are no attachments currently associated with this device."
          :per-page="perPage"
          :current-page="currentPage"
          @row-dblclicked="rowDblClickHandler"
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(Action)="{ item }">
            <b-button
              variant="outline-info"
              size="sm"
              v-on:click="
                showActionModal(item[0], item[1], item[2], item[3], item[4])
              "
            >
              View Details
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-modal
      ref="DeviceAttachModal"
      id="DeviceAttachModal"
      hide-footer
      title="Attachment Details"
      content-class="Modal"
    >
      <b-card
        border-variant="secondary"
        align="center"
        header-bg-variant="light"
        footer-tag="footer"
      >
        <b-row
          ><b-col>Device: {{ HumanName }} </b-col></b-row
        >
        <b-row
          ><b-col>Attached By: {{ item4 }}</b-col>
        </b-row>
        <b-row>
          <b-col>On: {{ item1 }} at {{ item2 }}</b-col></b-row
        >
        <b-row>
          <b-col>Attachment Name: {{ item3 }}</b-col>
        </b-row>
        <b-row><b-col>What would you like to do with attachment?</b-col></b-row>
      </b-card>
      <br />
      <div>
        <b-row>
          <b-col>
            <b-button
              variant="outline-info"
              size="sm"
              v-on:click="DownloadAttachment(item3)"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-button
              variant="outline-danger"
              size="sm"
              v-on:click="DeleteAttachment(item3)"
              >Delete</b-button
            >
          </b-col>
          <b-col>
            <b-button variant="outline-info" size="sm" v-on:click="resetmodal()"
              >Cancel</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { singleUpload, directDownloadByKey } from "@/Services/aws.js";
import { BIconCloudArrowUpFill, BIconFilePlusFill } from "bootstrap-vue";
import { delay } from "q";

export default {
  computed: {},
  components: {
    BIconCloudArrowUpFill,
    BIconFilePlusFill,
  },

  data() {
    return {
      file: "",
      DeviceID: this.$DeviceID,
      HumanName: this.$HumanName,
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      NewHeaders: [
        { key: "0", label: "Device ID", thClass: "d-none", tdClass: "d-none" },
        {
          key: "1",
          label: "Upload Date",
          thClass: "d-none",
          tdClass: "d-none",
        },
        {
          key: "2",
          label: "Upload Time",
          thClass: "d-none",
          tdClass: "d-none",
        },
        { key: "3", label: "Attachment Name" },
        { key: "4", label: "Uploader Name" },
        { key: "Action" },
      ],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/attachments";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LoadAll",
      RequestVariable: this.DeviceID,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        response;
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      });
  },

  methods: {
    handleFileUpload() {
      this.file = event.target.files[0];
    },
    submitFile() {
      this.isExist();
      if (this.file == "") {
        alert("Please select a file to upload");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.size > 2000000) {
        alert("file selected is too large, maximum file size is 2mb");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.duplicatefile == true) {
        alert(
          "File with this name already exists, uploading will overwrite current file. Please delete existing file or change name of file to be uploaded."
        );
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.name.indexOf(" ") >= 0) {
        alert("File Name should not contain spaces");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      } else {
        this.uploadFile(this.file);
      }
    },

    isExist: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][3] == this.file.name) {
          this.duplicatefile = true;
          return true;
        }
      }
      this.duplicatefile = false;
      return false;
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    async uploadFile() {
      this.showOverlay = true;
      await delay(5000);
      const result = await singleUpload(
        this.file,
        this.DeviceID + "/" + this.Folder // folder of the file, you should change it to your variable or a string
      );
      if (result.status === 200) {
        this.showOverlay = false;
        alert("File upload successful");
        this.filePath = result.fullPath;
        this.submitFileToDB(this.file.name, this.filePath);
        this.file = "";
        document.getElementById("file-upload").value = null;
      } else {
        alert("Upload Failed");
      }
      return {
        abort: () => {},
      };
    },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = localStorage.getItem("UserURN");
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.DeviceID,
            FileName: FileSave,
            FileURL: FileLocation,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.refreshTable();
        });
    },

    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    async DownloadAttachment(filekey) {
      let attachment = this.DeviceID + "/attachments/" + filekey;
      const res = await directDownloadByKey(attachment);
      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filekey); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
      alert("file download complete");
      this.$refs["DeviceAttachModal"].hide();
      this.refreshTable();
    },
    DeleteAttachment(delvar1) {

      if (confirm('Are you sure you wish to delete this attachment')){
        this.DeleteUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Delete",
        RequestVariable: delvar1,
        DataDict: [
          {
            ClearedURN: this.DeleteUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.$refs["DeviceAttachModal"].hide();
          this.refreshTable();
        });
      } else {
        this.$refs["DeviceAttachModal"].hide()
      }
},
    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },
    refreshTable() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LoadAll",
        RequestVariable: this.DeviceID,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
